import React from "react";
import { Button, makeStyles, Typography } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import styles from "../../../styles/global-styles";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/shoppingCart";
import { actions as actionsAlert } from "../../../redux/actions/alert";
import ProductCard from "../../stateless/ProductCard";
import NumberFormat from "react-number-format";
import { isBalanceTransferInCart } from "../../../_utils/utils";

const useStyles = makeStyles(() => ({
  body: styles.body,
  title: styles.title,
  backgroundIcon: styles.backgroundIcon,
}));

const MovileCard = ({
  addAlert,
  detailAlert,
  addItemToCart,
  product,
  shoppingCart: { cart },
}) => {
  const classes = useStyles();
  console.log("product", product);
  const {
    id,
    movile: {
      brand,
      model,
      barCode,
      price,
      discount,
      color,
      imeiCode,
      provider,
    },
  } = product;

  const productExistInShoppingCart = () => {
    return Object.keys(cart).some((idProduct) => idProduct === id);
  };

  const handleAddItemToCart = () => {
    if (isBalanceTransferInCart(cart)) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "info",
        message:
          "Ya tienes en el carrito un trapaso de saldo. Favor de eliminar para continuar",
      });
      return;
    } else {
      addItemToCart({ item: product, quantity: 1 });
    }
  };

  return (
    <>
      <ProductCard isMovile>
        <div style={{ maxWidth: 300 }}>
          <Typography className={classes.body}>Marca y modelo </Typography>
          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
            {brand} {model}
          </Typography>
        </div>
        <div>
          <Typography className={classes.body}>IMEI</Typography>
          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
            {imeiCode}
          </Typography>
        </div>
        <div>
          <Typography className={classes.body}>Color</Typography>
          <Typography variant="subtitle1">{color}</Typography>
        </div>
        <div style={{ maxWidth: 250 }}>
          <Typography className={classes.body}>Código de barras</Typography>
          <Typography variant="subtitle1">{barCode}</Typography>
        </div>
        <div style={{ maxWidth: 200 }}>
          <Typography variant="subtitle1" className={classes.body}>
            Precio x unidad
          </Typography>
          <Typography variant="body1" style={{ fontWeight: 800, fontSize: 20 }}>
            <NumberFormat
              value={price}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          </Typography>
        </div>
        <div style={{ maxWidth: 150 }}>
          <Typography className={classes.body}>Descuento</Typography>
          <Typography variant="subtitle1">
            {discount ? (
              <NumberFormat
                value={discount}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            ) : (
              "N/A"
            )}
          </Typography>
        </div>
        <div>
          <Typography className={classes.body}>Proveedor</Typography>
          <Typography variant="subtitle1">{provider?.alias || ""}</Typography>
        </div>
        <div style={{ maxWidth: 250 }}>
          <Button
            variant="contained"
            color="primary"
            disabled={productExistInShoppingCart()}
            onClick={() => handleAddItemToCart()}
            endIcon={
              <AddIcon
                className={classes.backgroundIcon}
                color="primary"
              ></AddIcon>
            }
          >
            Agregar
          </Button>
        </div>
      </ProductCard>
    </>
  );
};

const dispatch = {
  detailAlert: actionsAlert.detailAlert,
  addAlert: actionsAlert.addAlert,
  addItemToCart: actions.addItemToCart,
  removeItemFromCart: actions.removeItemFromCart,
};

const mapStateToProps = (state) => ({
  shoppingCart: state.shoppingCart,
});

export default connect(mapStateToProps, dispatch)(MovileCard);
